import React, { useEffect } from 'react';
import AsyncSelect from 'react-select/async';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { reactSelectCustomStyleCms } from 'helper';
import { GET_BUSINESS_LINE } from '../constants';
import { getBusinessLine } from '../actions';

const selectList = ({ api }) => {
  return _.get(api, `${GET_BUSINESS_LINE}.list`) || [];
};

const formatOptions = (data) => {
  return data.map((item) => {
    return {
      label: _.get(item, 'attributes.name'),
      value: _.get(item, 'id'),
      fullInfo: item,
      code: _.get(item, 'attributes.code'),
    };
  });
};

const BusinessLine = ({ onChange, name, value, readOnly, type, disabled }) => {
  const dispatch = useDispatch();
  const list = useSelector(selectList);
  const options = formatOptions(list);
  const findValue = value
    ? options.find((item) => +_.get(item, 'value', 0) === +value)
    : '';

  useEffect(() => {
    dispatch(getBusinessLine());
  }, []);

  const handleChange = (data) => {
    onChange({
      target: {
        name,
        value: data ? data.value : '',
        label: data ? data.label : '',
        code: data ? data.code : '',
      },
    });
  };

  const loadOptions = (inputValue, callback) => {
    dispatch(
      getBusinessLine({ q: inputValue }, (response) => {
        callback(formatOptions(_.get(response, 'data')));
      })
    );
  };

  const loadOptionsDebounce = _.debounce(loadOptions, 500);

  return readOnly === true ? (
    <span
      className={`text-uppercase ${
        type === 'mobile' ? 'span-input-mobile' : 'full-input'
      }`}
    >
      {_.get(findValue, 'label')}
    </span>
  ) : (
    <AsyncSelect
      styles={reactSelectCustomStyleCms()}
      // isClearable
      placeholder="- Type to Search -"
      value={findValue}
      defaultOptions={formatOptions(list)}
      loadOptions={loadOptionsDebounce}
      onChange={handleChange}
      isDisabled={disabled}
      components={{
        IndicatorSeparator: () => null,
      }}
    />
  );
};

BusinessLine.defaultProps = {
  name: undefined,
  readOnly: undefined,
  type: '',
  disabled: false,
};

BusinessLine.propTypes = {
  readOnly: PropTypes.bool,
  onChange: PropTypes.instanceOf(Function).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool,
};

export default BusinessLine;
